import React, { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useI18n, SUPPORTED, LANGUAGE_NAMES, LANGUAGE_FLAGS } from "../../i18n";
import { cn } from "../../lib/utils";

export function LanguageSelector({ compact = false, align = "right" }) {
  const { lang, setLanguage, t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-background/60 px-2.5 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent"
        aria-label={t("common.language")}
        aria-expanded={open}
      >
        <Globe className="h-4 w-4" />
        {!compact && <span className="uppercase">{lang}</span>}
        <ChevronDown className={cn("h-3.5 w-3.5 transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div
          className={cn(
            "absolute z-50 mt-2 w-44 overflow-hidden rounded-xl border border-border bg-popover p-1 shadow-lg animate-scale-in",
            align === "right" ? "right-0" : "left-0"
          )}
        >
          {SUPPORTED.map((code) => (
            <button
              key={code}
              onClick={() => {
                setLanguage(code);
                setOpen(false);
              }}
              className={cn(
                "flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm transition-colors hover:bg-accent",
                lang === code ? "font-semibold text-foreground" : "text-muted-foreground"
              )}
            >
              <span className="text-base">{LANGUAGE_FLAGS[code]}</span>
              <span className="flex-1 text-left">{LANGUAGE_NAMES[code]}</span>
              {lang === code && <Check className="h-4 w-4 text-brand" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
